export enum UserMissionEnum {
  READER = 'READER',
  WRITER = 'WRITER',
  EBOOK_READER = 'EBOOK_READER',
  EBOOK_WRITER = 'EBOOK_WRITER',
}

export enum ChallengeUnit {
  CHAPTER = 'CHAPTER',
  BOOK = 'BOOK',
  USER = 'USER',
  VIEW = 'VIEW',
  LOVE = 'LOVE',
  COIN = 'COIN',
}

export enum ChallengeUnitValue {
  CHAPTER = 'ตอน',
  BOOK = 'เรื่อง',
  USER = 'คน',
  VIEW = 'วิว',
  LOVE = 'เลิฟ',
  COIN = 'เหรียญ',
}
